import { render, staticRenderFns } from "./AppWebcam.vue?vue&type=template&id=59fa9358&scoped=true&"
import script from "./AppWebcam.vue?vue&type=script&lang=js&"
export * from "./AppWebcam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fa9358",
  null
  
)

export default component.exports